<template>
    <div class="2xl:w-full 2xl:mx-auto">
        <NuxtPage />
    </div>
</template>
